import * as React from "react";
import {useState} from "react";
import {InputControlComponentProps} from "../../types/types";
import {useLeadStore} from "../leadgeneration/store/Lead.store";
import './inputControl.component.scss';
import {InputValidatorProps, ValidateInput} from "./validation/InputValidator";

export const InputControlComponent = ( {
                                           placeholder,
                                           type,
                                           theme,
                                           currentValue,
                                           onChange,
                                           required,
                                           maxLength,
                                           describedBy,
                                           inputHelpText,
                                           appendText
                                       }: InputControlComponentProps ) => {
    const [isValid, setIsValid] = useState( '' );
    const store = useLeadStore();

    const onBlur = ( e: any ) => {
        const validationProps: InputValidatorProps = {
            e: e,
            required: required,
            type: type,
            setValidationMessage: setIsValid,
            extraData: {invalidDomains: store.configuration.invalidDomains.slice()}
        };

        ValidateInput( validationProps )
    };

    const handleKeyPress = ( e: any ) => {
        if ( e.key === 'Enter' && e.shiftKey === false ) {
            e.preventDefault();
        }
    };

    let classNames = 'form-control input-control';
    if ( isValid !== '' ) {
        classNames += " is-invalid";
    }

    if ( typeof theme !== 'undefined' && theme ) {
        classNames += ' ' + theme;
    }

    return (<div className={(appendText !== undefined) ? 'input-group': ''}>
        <input type={type}
               className={classNames}
               placeholder={placeholder}
               required={required}
               value={currentValue}
               maxLength={maxLength}
               onChange={( e ) => onChange( e )}
               onBlur={onBlur}
               aria-describedby={describedBy}
               onKeyPress={handleKeyPress}
        />
        {appendText !== undefined && <div className={'input-group-append'}>
            <span className={'input-group-text'} id={describedBy}>{appendText}</span>
        </div>}
        {inputHelpText}
        {isValid !== '' && <div className="invalid-feedback">
            {store.translate( isValid )}
        </div>}

    </div>);
};
